import { render, staticRenderFns } from "./RegistrarConvocatoriasDialogComponent.vue?vue&type=template&id=a3c6ac5c&scoped=true"
import script from "./RegistrarConvocatoriasDialogComponent.vue?vue&type=script&lang=js"
export * from "./RegistrarConvocatoriasDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./RegistrarConvocatoriasDialogComponent.vue?vue&type=style&index=0&id=a3c6ac5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c6ac5c",
  null
  
)

export default component.exports